import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AndroidComponent } from './android.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AndroidComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ]
})
export class AndroidModule { }
